import * as THREE from 'three';
import { StormFx, type WeatherLike } from './StormFx';

export type { WeatherLike } from './StormFx';

/**
 * Client entry point for storm weather rendering.
 *
 * Thin wrapper over `StormFx` matching the frozen interface the integration
 * agent wires into `Game`: construct with the scene/camera/mobile flag, feed it
 * the server-published weather each frame, and dispose it with the rest of the
 * scene graph. Rain density/quality is already scaled by `mobile` inside
 * `StormFx`, which also shifts the ambient/directional light cold and dim as
 * the storm builds.
 */
export class WeatherSystem {
  private readonly fx: StormFx;

  constructor(scene: THREE.Scene, camera: THREE.PerspectiveCamera, mobile: boolean) {
    this.fx = new StormFx(scene, camera, mobile);
  }

  update(delta: number, weather: WeatherLike): void {
    this.fx.update(delta, weather);
  }

  dispose(): void {
    this.fx.dispose();
  }
}
